/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { ClientBase } from "../../../../schema/generated/Client";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class ClientDataApi extends EntityDataApi<ClientBase> {
  public readonly def = idbEntityDefs.Client;
}